import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CustomTabs } from "../../Components/CustomTabs";
import { ViewDispatch } from "./ViewDispatch";
import { Dispatched } from "./Dispatched";
import { SalesRegisterView } from "./SalesRegisterView";
import { ExportView } from "./ExportView";
import BlankLrView from "./BlankLrView";
import UploadedPODs from "./UploadedPODs";
import { DispatchPackagingView } from "./DispatchPackaging/DispatchPackagingView";
export const AllDispatchTabView = () => {
  const userData = useSelector((state) => state.auth.profile);

  const isInGroups = (...groups) =>
    groups.some((group) => userData.groups.includes(group));

  const allTabs = isInGroups(
    "Director",
    "Accounts",
    "Sales Manager",
    "Sales Manager(Retailer)",
    "Sales Executive",
    "Customer Relationship Manager",
    "Customer Relationship Executive",
    "Sales Deputy Manager",
    "Sales Assistant Deputy Manager",
    "Business Development Manager",
    "Business Development Executive",
    "Operations & Supply Chain Manager",
  );

  const twoTabs = isInGroups(
    "Factory-Delhi-Dispatch",
    "Factory-Mumbai-Dispatch",
    "Stores Delhi",
    "Production Delhi",
    "Account Billing Department",
    "Accounts",
  );
  const dispatchPODPending = isInGroups("Customer Service");
  const dispatchLRPending = isInGroups(
    "Factory-Mumbai-Dispatch",
    "Factory-Delhi-Dispatch",
  );
  const isAdmin = isInGroups(
    "Director",
    "Operations & Supply Chain Manager",
    "Stores",
  );
  const factory = isInGroups("Factory-Mumbai-Dispatch");
  const adminTab = isInGroups("Director", "Operations & Supply Chain Manager");
  const customerServiceTab = isInGroups("Customer Service");
  const salesRegisterTab = isInGroups("Accounts Billing Department");
  const isAccpuntExecutive = isInGroups("Accounts Executive");
  const isStores = isInGroups("Stores");
  const factoryDispatchTab = isInGroups("Factory-Mumbai-OrderBook");
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: "Pending Dispatch",
      visible: allTabs || twoTabs || factoryDispatchTab || customerServiceTab,
      index: 0,
    },

    {
      label: dispatchPODPending
        ? "Dispatch-POD Pending"
        : dispatchLRPending
          ? "Dispatched-LR Pending"
          : "Dispatch",
      visible: allTabs || twoTabs || customerServiceTab || factoryDispatchTab,
      index: 1,
    },

    {
      label: "Export Invoice",
      visible: allTabs || twoTabs || customerServiceTab,
      index: 2,
    },

    {
      label: "Sales Register",
      visible:
        allTabs ||
        customerServiceTab ||
        salesRegisterTab ||
        isAccpuntExecutive ||
        isStores ||
        factoryDispatchTab,
      index: 3,
    },
    {
      label: "Pending LR Copy",
      visible: adminTab || dispatchPODPending || isStores || factoryDispatchTab,
      index: 4,
    },
    {
      label: "Uploaded POD",
      visible: adminTab || factoryDispatchTab,
      index: 5,
    },
    {
      label: "Packaging Consumption",
      visible: isAdmin || factory || isAccpuntExecutive,
      index: 6,
    },
  ];

  const visibleTabs = tabs.filter((tab) => tab.visible);
  const visibleTabIndexes = visibleTabs.map((tab) => tab.index);

  const tabComponents = {
    0: <ViewDispatch />,
    1: <Dispatched />,
    2: <ExportView />,
    3: <SalesRegisterView />,
    4: <BlankLrView />,
    5: <UploadedPODs />,
    6: <DispatchPackagingView />,
  };
  return (
    <div>
      <CustomTabs
        tabs={visibleTabs}
        activeTab={activeTab}
        onTabChange={(index) => setActiveTab(index)}
      />

      <div>{tabComponents[visibleTabIndexes[activeTab]]}</div>
    </div>
  );
};
